// Kept at v1 so dismissals stored while the upsell modal existed still count.
// Their leftover modalLastShownAt field is never read.
const STORAGE_KEY = 'ffhub_app_upsell_v1';

export type StoredAppUpsell = {
  /** Epoch ms of when the banner was last dismissed. */
  bannerDismissedAt: number;
};

export const getStoredAppUpsell = (): StoredAppUpsell | null => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<StoredAppUpsell> | null;
    const bannerDismissedAt = parsed?.bannerDismissedAt;
    if (
      typeof bannerDismissedAt !== 'number' ||
      !Number.isFinite(bannerDismissedAt)
    ) {
      return null;
    }
    return { bannerDismissedAt };
  } catch {
    return null;
  }
};

export const setStoredAppUpsell = (value: StoredAppUpsell): void => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // Silently fail - localStorage may be full or disabled
  }
};
